export default __webpack_public_path__ + "static/media/ci-logo.8ebfdd1c.jpg";